/* Packages */
import React from 'react';
import {render} from 'react-dom';

/* Helpers */
import {parseDataToProps} from '../helpers';

const countdownNodes = document.querySelectorAll('.countdown');

if (countdownNodes.length > 0) {
    import(/* webpackChunkName: "Countdown" */ './components/Countdown').then(({default: Countdown}) => {[...countdownNodes].forEach((node) => render(<Countdown {...parseDataToProps(node.dataset)} />, node));
    });
}
